import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { API_URL } from '../config';
import DashboardLayout from '../DashboardLayout/DasboardLayout';
import { motion } from "framer-motion";

const AdminDashboard = () => {
  const [account_type, setAccount_type] = useState("");
  const [account_category, setAccount_category] = useState("");
  const [signed_on, setSigned_on] = useState("");
  const [name, setName] = useState("");
  const [hseNo, setHseNo] = useState("");
  const [surbub, setSurbub] = useState("");
  const [city, setCity] = useState("");
  const [country, setCountry] = useState("");
  const [email, setEmail] = useState("");
  const [membershipstatus, setMembershipStatus] = useState("");
  const [topUpList, setTopUpList] = useState([]);
  const [isAdmin, setIsAdmin] = useState(false);
  const [usage, setUsage] = useState('0');
  const [balance, setBalance] = useState('0');
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'ascending' });
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const APILINK = API_URL;

  const async_client_profile_id = localStorage.getItem('async_client_profile_id');

  useEffect(() => {
    const role = "Admin";
    if (role === 'Admin') {
      setIsAdmin(true);
    }
    if (role === '' || role === null) {
      window.location.href = '/';
    }

    fetchTopUp();
    getBalance();
    getClientDetails();
  }, []);

  const getBalance = () => {
    setLoading(true);
    fetch(`${API_URL}/topUp/adminbal`).then(res => {
      return res.json();
    }).then(resp => {
      console.log('Balance API response:', resp);
      
      // If adminbal returns empty array, calculate from topup data
      if (Array.isArray(resp) && resp.length === 0) {
        // Fetch topup data to calculate balance
        fetch(`${API_URL}/topUp/`).then(topupRes => {
          return topupRes.json();
        }).then(topupResp => {
          console.log('Topup data for balance calculation:', topupResp);
          
          if (topupResp.results && topupResp.results.length > 0) {
            // Filter transactions where folio is "RW"
            const rwTransactions = topupResp.results.filter(item => item.folio === "RW");
            console.log("RW transactions for balance:", rwTransactions);
            
            if (rwTransactions.length > 0) {
              // Get the most recent RW record with balance data
              const latestRecord = rwTransactions[0]; // Assuming first record is the latest
              
              // Extract balance values with fallbacks
              const revenueWalletBalance = parseFloat(latestRecord.revenue_wallet_balance) || 0;
              const revenueWalletCredit = parseFloat(latestRecord.revenue_wallet_credit) || 0;
              const revenueWalletDebit = parseFloat(latestRecord.revenue_wallet_debit) || 0;
              
              console.log('RW Revenue Balance values:', {
                revenueWalletBalance,
                revenueWalletCredit,
                revenueWalletDebit
              });
              
              // Set balance and usage correctly for revenue wallet
              setBalance(revenueWalletBalance); // Current available balance: 0
              setUsage(revenueWalletDebit); // Usage/debit amount: 0
            } else {
              // No RW transactions found
              console.log('No RW transactions found');
              setBalance(0);
              setUsage(0);
            }
          } else {
            // No data available, set to 0
            setBalance(0);
            setUsage(0);
          }
          setLoading(false);
        }).catch((err) => {
          console.error('Error fetching topup data for balance:', err);
          setBalance(0);
          setUsage(0);
          setLoading(false);
        });
      } else {
        // Original logic for when adminbal works
        const balanceValue = resp?.results?.[0]?.total_balance || resp?.total_balance || 0;
        const usageValue = resp?.results?.[0]?.total_usage || resp?.total_usage || 0;
        
        setBalance(balanceValue);
        setUsage(usageValue);
        setLoading(false);
      }
    }).catch((err) => {
      console.error('Error fetching balance:', err);
      // Set default values on error
      setBalance(0);
      setUsage(0);
      setLoading(false);
    });
  };

  const getClientDetails = () => {
    fetch(`${API_URL}/clients/${async_client_profile_id}`).then(res => {
      return res.json();
    }).then(resp => {
      setName(resp[0].name);
      setAccount_type(resp[0].account_type);
      setAccount_category(resp[0].account_category);
      setSigned_on(resp[0].signed_on);
      setCountry(resp[0].country);
      setEmail(resp[0].email);
      setMembershipStatus(resp[0].membershipstatus);
      setHseNo(resp[0].house_number_and_street_name);
      setSurbub(resp[0].surbub);
      setCity(resp[0].city);
    }).catch((err) => {
      console.log(err.message);
    });
  };

  const fetchTopUp = async () => {
    try {
      setLoading(true);
      const response = await fetch(`${APILINK}/topUp/`);
      if (!response.ok) {
        throw new Error(`Error: ${response.status}`);
      }
      const data = await response.json();
      console.log("jwefwjfjwejfjwejfnejnfjwejejenjenjenjeejnejejnwfej");
      console.log(data,"data_____________________________-");
      if (Array.isArray(data.results)) {
        // Filter transactions where folio is "RW"
        const rwTransactions = data.results.filter(item => item.folio === "RW");
        console.log("RW transactions:", rwTransactions);
        setTopUpList(rwTransactions);
      } else {
        setTopUpList([]);
      }
      setLoading(false);
    } catch (error) {
      console.error('Failed to fetch top-up data:', error);
      setTopUpList([]);
      setLoading(false);
    }
  };

  // Sorting function
  const requestSort = (key) => {
    let direction = 'ascending';
    if (sortConfig.key === key && sortConfig.direction === 'ascending') {
      direction = 'descending';
    }
    setSortConfig({ key, direction });
  };

  // Apply sorting to data
  const sortedData = React.useMemo(() => {
    let sortableItems = [...topUpList];
    if (sortConfig.key) {
      sortableItems.sort((a, b) => {
        if (a[sortConfig.key] < b[sortConfig.key]) {
          return sortConfig.direction === 'ascending' ? -1 : 1;
        }
        if (a[sortConfig.key] > b[sortConfig.key]) {
          return sortConfig.direction === 'ascending' ? 1 : -1;
        }
        return 0;
      });
    }
    return sortableItems;
  }, [topUpList, sortConfig]);

  // Filter data by search term
  const filteredData = sortedData.filter(item => 
    item.description?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    item.client_profile_id?.toString().includes(searchTerm) ||
    item.top_up_id?.toString().includes(searchTerm)
  );

  // Pagination
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredData.length / itemsPerPage);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  // Format currency
  const formatCurrency = (value) => {
    // Handle NaN, undefined, null, and invalid values
    const numValue = parseFloat(value);
    if (isNaN(numValue) || !isFinite(numValue)) {
      return '$0.00';
    }
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2
    }).format(numValue);
  };

  return (
    <DashboardLayout>
      <div className="bg-white min-h-screen">
        <div className="p-4 sm:p-6 lg:p-8">
          <div className="mb-8">
            <h1 className="text-3xl font-bold text-gray-800 mb-2">Admin Dashboard</h1>
            <p className="text-gray-600">Welcome back, {name || 'Admin'}. Here's your financial overview.</p>
          </div>

          {/* Stats Cards */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
            <motion.div 
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="bg-white rounded-xl shadow-md overflow-hidden border border-gray-100"
            >
              <div className="p-6">
                <div className="flex items-center mb-4">
                  <div className="w-12 h-12 rounded-full bg-blue-100 flex items-center justify-center mr-4">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                  </div>
                  <div>
                    <p className="text-sm font-medium text-gray-500">Total Balance</p>
                    <h2 className="text-2xl font-bold text-gray-800">
                      {loading ? (
                        <div className="animate-pulse h-8 w-24 bg-gray-200 rounded"></div>
                      ) : (
                        formatCurrency((parseFloat(balance) || 0) + (parseFloat(usage) || 0))
                      )}
                    </h2>
                  </div>
                </div>
                <div className="w-full bg-gray-100 rounded-full h-1.5">
                  <div className="bg-blue-600 h-1.5 rounded-full" style={{ width: '75%' }}></div>
                </div>
              </div>
            </motion.div>

            <motion.div 
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3, delay: 0.1 }}
              className="bg-white rounded-xl shadow-md overflow-hidden border border-gray-100"
            >
              <div className="p-6">
                <div className="flex items-center mb-4">
                  <div className="w-12 h-12 rounded-full bg-red-100 flex items-center justify-center mr-4">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-red-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z" />
                    </svg>
                  </div>
                  <div>
                    <p className="text-sm font-medium text-gray-500">Billing Usage</p>
                    <h2 className="text-2xl font-bold text-gray-800">
                      {loading ? (
                        <div className="animate-pulse h-8 w-24 bg-gray-200 rounded"></div>
                      ) : (
                        formatCurrency(usage || 0)
                      )}
                    </h2>
                  </div>
                </div>
                <div className="w-full bg-gray-100 rounded-full h-1.5">
                  <div className="bg-red-500 h-1.5 rounded-full" style={{ width: '45%' }}></div>
                </div>
              </div>
            </motion.div>

            <motion.div 
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3, delay: 0.2 }}
              className="bg-white rounded-xl shadow-md overflow-hidden border border-gray-100"
            >
              <div className="p-6">
                <div className="flex items-center mb-4">
                  <div className="w-12 h-12 rounded-full bg-green-100 flex items-center justify-center mr-4">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                  </div>
                  <div>
                    <p className="text-sm font-medium text-gray-500">Billing Prepaid</p>
                    <h2 className="text-2xl font-bold text-gray-800">
                      {loading ? (
                        <div className="animate-pulse h-8 w-24 bg-gray-200 rounded"></div>
                      ) : (
                        formatCurrency(balance || 0)
                      )}
                    </h2>
                  </div>
                </div>
                <div className="w-full bg-gray-100 rounded-full h-1.5">
                  <div className="bg-green-500 h-1.5 rounded-full" style={{ width: '60%' }}></div>
                </div>
              </div>
            </motion.div>
          </div>

          {/* Billing Section */}
          <motion.div 
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4, delay: 0.3 }}
            className="bg-white rounded-xl shadow-md overflow-hidden mb-8 border border-gray-100"
          >
            <div className="p-6">
              <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-6">
                <h2 className="text-2xl font-bold text-gray-800 mb-4 sm:mb-0">Billing Transactions</h2>
                <div className="flex flex-col sm:flex-row space-y-3 sm:space-y-0 sm:space-x-3 w-full sm:w-auto">
                  <div className="relative">
                    <input
                      type="text"
                      placeholder="Search transactions..."
                      className="pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 w-full sm:w-64"
                      value={searchTerm}
                      onChange={(e) => {
                        setSearchTerm(e.target.value);
                        setCurrentPage(1);
                      }}
                    />
                    <div className="absolute left-3 top-2.5 text-gray-400">
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                      </svg>
                    </div>
                  </div>
                  <Link
                    to="/searchTrip"
                    className="inline-flex items-center justify-center px-4 py-2 border border-transparent rounded-lg shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors duration-200"
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 16l2.879-2.879m0 0a3 3 0 104.243-4.242 3 3 0 00-4.243 4.242zM21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                    Search Trip
                  </Link>
                </div>
              </div>

              {loading ? (
                <div className="animate-pulse space-y-4">
                  <div className="h-10 bg-gray-200 rounded w-full"></div>
                  {[...Array(5)].map((_, i) => (
                    <div key={i} className="h-16 bg-gray-200 rounded w-full"></div>
                  ))}
                </div>
              ) : (
                <>
                  <div className="overflow-x-auto">
                    <table className="min-w-full divide-y divide-gray-200">
                      <thead className="bg-gray-50">
                        <tr>
                          <th 
                            scope="col" 
                            className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer hover:bg-gray-100"
                            onClick={() => requestSort('top_up_id')}
                          >
                            <div className="flex items-center">
                              Top Up ID
                              {sortConfig.key === 'top_up_id' && (
                                <span className="ml-1">
                                  {sortConfig.direction === 'ascending' ? '↑' : '↓'}
                                </span>
                              )}
                            </div>
                          </th>
                          <th 
                            scope="col" 
                            className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer hover:bg-gray-100"
                            onClick={() => requestSort('client_profile_id')}
                          >
                            <div className="flex items-center">
                              Client ID
                              {sortConfig.key === 'client_profile_id' && (
                                <span className="ml-1">
                                  {sortConfig.direction === 'ascending' ? '↑' : '↓'}
                                </span>
                              )}
                            </div>
                          </th>
                          <th 
                            scope="col" 
                            className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer hover:bg-gray-100"
                            onClick={() => requestSort('date')}
                          >
                            <div className="flex items-center">
                              Date
                              {sortConfig.key === 'date' && (
                                <span className="ml-1">
                                  {sortConfig.direction === 'ascending' ? '↑' : '↓'}
                                </span>
                              )}
                            </div>
                          </th>
                          <th 
                            scope="col" 
                            className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer hover:bg-gray-100"
                            onClick={() => requestSort('description')}
                          >
                            <div className="flex items-center">
                              Description
                              {sortConfig.key === 'description' && (
                                <span className="ml-1">
                                  {sortConfig.direction === 'ascending' ? '↑' : '↓'}
                                </span>
                              )}
                            </div>
                          </th>
                          <th 
                            scope="col" 
                            className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer hover:bg-gray-100"
                            onClick={() => requestSort('revenue_wallet_debit')}
                          >
                            <div className="flex items-center">
                              Debit
                              {sortConfig.key === 'revenue_wallet_debit' && (
                                <span className="ml-1">
                                  {sortConfig.direction === 'ascending' ? '↑' : '↓'}
                                </span>
                              )}
                            </div>
                          </th>
                          <th 
                            scope="col" 
                            className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer hover:bg-gray-100"
                            onClick={() => requestSort('revenue_wallet_credit')}
                          >
                            <div className="flex items-center">
                              Credit
                              {sortConfig.key === 'revenue_wallet_credit' && (
                                <span className="ml-1">
                                  {sortConfig.direction === 'ascending' ? '↑' : '↓'}
                                </span>
                              )}
                            </div>
                          </th>
                          <th 
                            scope="col" 
                            className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer hover:bg-gray-100"
                            onClick={() => requestSort('revenue_wallet_balance')}
                          >
                            <div className="flex items-center">
                              Balance
                              {sortConfig.key === 'revenue_wallet_balance' && (
                                <span className="ml-1">
                                  {sortConfig.direction === 'ascending' ? '↑' : '↓'}
                                </span>
                              )}
                            </div>
                          </th>
                          <th 
                            scope="col" 
                            className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer hover:bg-gray-100"
                            onClick={() => requestSort('currency')}
                          >
                            <div className="flex items-center">
                              Currency
                              {sortConfig.key === 'currency' && (
                                <span className="ml-1">
                                  {sortConfig.direction === 'ascending' ? '↑' : '↓'}
                                </span>
                              )}
                            </div>
                          </th>
                          <th 
                            scope="col" 
                            className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer hover:bg-gray-100"
                            onClick={() => requestSort('exchange_rate')}
                          >
                            <div className="flex items-center">
                              Exchange Rate
                              {sortConfig.key === 'exchange_rate' && (
                                <span className="ml-1">
                                  {sortConfig.direction === 'ascending' ? '↑' : '↓'}
                                </span>
                              )}
                            </div>
                          </th>
                        </tr>
                      </thead>
                      <tbody className="bg-white divide-y divide-gray-200">
                        {currentItems.length > 0 ? (
                          currentItems.map((item, index) => (
                            <motion.tr 
                              key={item.top_up_id}
                              initial={{ opacity: 0, y: 10 }}
                              animate={{ opacity: 1, y: 0 }}
                              transition={{ duration: 0.2, delay: index * 0.05 }}
                              className="hover:bg-gray-50 transition-colors duration-150"
                            >
                              <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">{item.top_up_id}</td>
                              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{item.client_profile_id}</td>
                              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                {new Date(item.date).toLocaleDateString('en-US', {
                                  year: 'numeric',
                                  month: 'short',
                                  day: 'numeric'
                                })}
                              </td>
                              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{item.description}</td>
                              <td className="px-6 py-4 whitespace-nowrap text-sm text-red-600 font-medium">
                                {item.revenue_wallet_debit > 0 ? formatCurrency(item.revenue_wallet_debit || 0) : '-'}
                              </td>
                              <td className="px-6 py-4 whitespace-nowrap text-sm text-green-600 font-medium">
                                {item.revenue_wallet_credit > 0 ? formatCurrency(item.revenue_wallet_credit || 0) : '-'}
                              </td>
                              <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                                {formatCurrency(item.revenue_wallet_balance || 0)}
                              </td>
                              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{item.currency}</td>
                              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{item.exchange_rate}</td>
                            </motion.tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="9" className="px-6 py-4 text-center text-sm text-gray-500">
                              No transactions found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>

                  {/* Pagination */}
                  {filteredData.length > itemsPerPage && (
                    <div className="flex items-center justify-between border-t border-gray-200 px-4 py-3 sm:px-6 mt-4">
                      <div className="hidden sm:flex-1 sm:flex sm:items-center sm:justify-between">
                        <div>
                          <p className="text-sm text-gray-700">
                            Showing <span className="font-medium">{indexOfFirstItem + 1}</span> to{' '}
                            <span className="font-medium">
                              {indexOfLastItem > filteredData.length ? filteredData.length : indexOfLastItem}
                            </span>{' '}
                            of <span className="font-medium">{filteredData.length}</span> results
                          </p>
                        </div>
                        <div>
                          <nav className="relative z-0 inline-flex rounded-md shadow-sm -space-x-px" aria-label="Pagination">
                            <button
                              onClick={() => paginate(currentPage > 1 ? currentPage - 1 : 1)}
                              disabled={currentPage === 1}
                              className={`relative inline-flex items-center px-2 py-2 rounded-l-md border border-gray-300 bg-white text-sm font-medium ${
                                currentPage === 1 ? 'text-gray-300 cursor-not-allowed' : 'text-gray-500 hover:bg-gray-50'
                              }`}
                            >
                              <span className="sr-only">Previous</span>
                              <svg className="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                                <path fillRule="evenodd" d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z" clipRule="evenodd" />
                              </svg>
                            </button>
                            
                            {/* Page numbers */}
                            {Array.from({ length: Math.min(5, totalPages) }).map((_, index) => {
                              let pageNumber;
                              
                              // Calculate which page numbers to show
                              if (totalPages <= 5) {
                                pageNumber = index + 1;
                              } else if (currentPage <= 3) {
                                pageNumber = index + 1;
                              } else if (currentPage >= totalPages - 2) {
                                pageNumber = totalPages - 4 + index;
                              } else {
                                pageNumber = currentPage - 2 + index;
                              }
                              
                              if (pageNumber <= totalPages) {
                                return (
                                  <button
                                    key={pageNumber}
                                    onClick={() => paginate(pageNumber)}
                                    className={`relative inline-flex items-center px-4 py-2 border text-sm font-medium ${
                                      currentPage === pageNumber
                                        ? 'z-10 bg-blue-50 border-blue-500 text-blue-600'
                                        : 'bg-white border-gray-300 text-gray-500 hover:bg-gray-50'
                                    }`}
                                  >
                                    {pageNumber}
                                  </button>
                                );
                              }
                              return null;
                            })}
                            
                            <button
                              onClick={() => paginate(currentPage < totalPages ? currentPage + 1 : totalPages)}
                              disabled={currentPage === totalPages}
                              className={`relative inline-flex items-center px-2 py-2 rounded-r-md border border-gray-300 bg-white text-sm font-medium ${
                                currentPage === totalPages ? 'text-gray-300 cursor-not-allowed' : 'text-gray-500 hover:bg-gray-50'
                              }`}
                            >
                              <span className="sr-only">Next</span>
                              <svg className="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                                <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd" />
                              </svg>
                            </button>
                          </nav>
                        </div>
                      </div>
                    </div>
                  )}
                </>
              )}
            </div>
          </motion.div>
        </div>
      </div>
    </DashboardLayout>
  );
};

export default AdminDashboard;